var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0489D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9517 111H39.2926V41.1818H63.429C70.3608 41.1818 76.3153 42.5795 81.2926 45.375C86.2926 48.1477 90.1335 52.1364 92.8153 57.3409C95.4972 62.5455 96.8381 68.7727 96.8381 76.0227C96.8381 83.2955 95.4858 89.5455 92.7812 94.7727C90.0994 100 86.2244 104.011 81.1562 106.807C76.1108 109.602 70.0426 111 62.9517 111ZM51.9403 100.057H62.3381C67.2017 100.057 71.2585 99.1705 74.5085 97.3977C77.7585 95.6023 80.2017 92.9318 81.8381 89.3864C83.4744 85.8182 84.2926 81.3636 84.2926 76.0227C84.2926 70.6818 83.4744 66.25 81.8381 62.7273C80.2017 59.1818 77.7813 56.5341 74.5767 54.7841C71.3949 53.0114 67.4403 52.125 62.7131 52.125H51.9403V100.057ZM166.23 41.1818V111H154.98L122.082 63.4432H121.503V111H108.855V41.1818H120.173L153.037 88.7727H153.651V41.1818H166.23ZM226.784 63.4773C226.216 61.6364 225.432 59.9886 224.432 58.5341C223.455 57.0568 222.273 55.7955 220.886 54.75C219.523 53.7045 217.955 52.9205 216.182 52.3977C214.409 51.8523 212.477 51.5795 210.386 51.5795C206.636 51.5795 203.295 52.5227 200.364 54.4091C197.432 56.2955 195.125 59.0682 193.443 62.7273C191.784 66.3636 190.955 70.7955 190.955 76.0227C190.955 81.2955 191.784 85.7614 193.443 89.4205C195.102 93.0795 197.409 95.8636 200.364 97.7727C203.318 99.6591 206.75 100.602 210.659 100.602C214.205 100.602 217.273 99.9205 219.864 98.5568C222.477 97.1932 224.489 95.2614 225.898 92.7614C227.307 90.2386 228.011 87.2841 228.011 83.8977L230.875 84.3409H211.92V74.4545H240.25V82.8409C240.25 88.8182 238.977 93.9886 236.432 98.3523C233.886 102.716 230.386 106.08 225.932 108.443C221.477 110.784 216.364 111.955 210.591 111.955C204.159 111.955 198.511 110.511 193.648 107.625C188.807 104.716 185.023 100.591 182.295 95.25C179.591 89.8864 178.239 83.5227 178.239 76.1591C178.239 70.5227 179.034 65.4886 180.625 61.0568C182.239 56.625 184.489 52.8636 187.375 49.7727C190.261 46.6591 193.648 44.2955 197.534 42.6818C201.42 41.0455 205.648 40.2273 210.216 40.2273C214.08 40.2273 217.682 40.7955 221.023 41.9318C224.364 43.0455 227.33 44.6364 229.92 46.7045C232.534 48.7727 234.682 51.2273 236.364 54.0682C238.045 56.9091 239.148 60.0455 239.67 63.4773H226.784Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.421 194.195C250.554 194.586 257.253 195.484 262.819 196.676L264.343 196.988L265.476 198.473C275.612 211.578 282.155 234.371 284.831 265.875C285.788 277.008 286.062 284.664 286.042 298.492C286.022 304.879 285.944 310.66 285.866 311.305L285.73 312.496L274.519 293.082L263.308 273.648L261.628 272.574C242.624 260.27 219.772 248.238 201.745 241.031C182.233 233.219 166.12 229.508 152.956 229.762C151.062 229.801 149.499 229.801 149.519 229.742C149.558 229.527 154.616 224.957 157.116 222.867C168.132 213.707 180.886 206.383 194.421 201.461C204.558 197.789 214.733 195.523 225.964 194.469C229.714 194.137 240.73 193.961 244.421 194.195Z",
    fill: "url(#paint0_linear_106_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.109 199.603C293.621 205.716 311.258 216.419 325.633 230.892C339.031 244.368 348.895 260.208 355.281 278.489L356.355 281.575L355.73 283.138C351.609 293.568 341.863 305.677 327.82 317.786C312.527 330.95 292.605 344.232 268.562 357.259C267.547 357.825 267.059 358.001 267.137 357.786C267.254 357.474 287.156 322.943 288.66 320.462C289.109 319.7 289.48 318.958 289.48 318.802C289.48 318.646 289.598 315.423 289.734 311.673C289.91 307.083 289.949 301.087 289.871 293.411C289.754 282.142 289.637 278.509 289.051 270.072C286.844 238.685 280.555 213.997 271.16 199.798C270.73 199.173 270.398 198.626 270.398 198.568C270.398 198.431 270.535 198.47 274.109 199.603Z",
    fill: "url(#paint1_linear_106_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.365 233.764C159.677 233.804 160.908 233.94 162.099 234.057C181.708 235.991 210.224 247.046 241.181 264.682C245.38 267.085 254.325 272.436 255.419 273.198C255.79 273.452 253.408 273.491 233.408 273.491H210.966L207.333 275.386C193.134 282.749 176.552 292.749 164.345 301.304C140.79 317.788 124.755 333.706 117.216 348.061C116.591 349.272 116.025 350.249 116.005 350.21C115.849 350.073 114.911 346.011 114.365 343.218C113.603 339.292 112.88 334.253 112.45 329.839C111.982 324.936 111.982 313.12 112.45 308.159C114.033 291.694 118.056 277.475 125.107 263.335C129.228 255.093 133.779 247.925 139.247 241.128C141.611 238.179 144.716 234.585 145.107 234.389C145.771 233.999 150.595 233.647 154.579 233.667C156.884 233.686 159.033 233.745 159.365 233.764Z",
    fill: "url(#paint2_linear_106_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.862 280.17C206.803 280.345 201.764 289.115 195.67 299.662C186.764 315.092 184.577 319.017 184.518 319.662C184.069 325.404 183.913 345.892 184.264 354.838C185.338 382.65 188.776 404.564 194.713 421.244C197.038 427.748 200.085 434.095 202.858 438.197C203.288 438.822 203.6 439.369 203.561 439.408C203.542 439.447 201.881 438.959 199.889 438.353C169.733 429.037 144.01 408.314 128.249 380.619C124.713 374.408 121.002 366.185 118.542 359.037L117.643 356.42L118.268 354.838C119.088 352.728 121.413 348.256 122.956 345.795C128.795 336.42 139.167 325.638 152.721 314.799C165.729 304.408 182.213 293.568 200.182 283.607C206.647 280.033 206.999 279.857 206.862 280.17Z",
    fill: "url(#paint3_linear_106_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.66 290.229C362.703 307.045 363.055 325.717 359.637 343.217C355.594 363.979 346.004 383.822 332.235 399.916C331.043 401.303 329.852 402.689 329.578 403.021C328.68 404.057 325.047 404.447 318.075 404.291C309.266 404.076 300.867 402.533 289.266 398.939C269.891 392.963 245.36 381.225 220.926 366.244L218.25 364.604L240.75 364.506L263.27 364.408L266.395 362.768C312 338.822 345.125 312.143 356.766 289.955C357.41 288.744 357.957 287.748 357.996 287.748C358.035 287.748 358.328 288.861 358.66 290.229Z",
    fill: "url(#paint4_linear_106_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 344.936L210.73 364.369L213.426 366.108C225.945 374.135 241.59 382.885 254.851 389.233C281.707 402.123 304.051 408.549 320.945 408.237C322.898 408.198 324.5 408.198 324.48 408.256C324.461 408.432 319.558 412.865 317.41 414.682C288.387 439.076 250.379 448.862 212.84 441.635L209.676 441.03L208.523 439.526C200.242 428.803 194.324 411.576 191.004 388.432C189.578 378.393 188.719 368.764 188.152 356.108C187.937 350.873 187.898 328.608 188.133 326.694L188.269 325.483L199.5 344.936Z",
    fill: "url(#paint5_linear_106_615)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_615",
    x: 27.293,
    y: 40.2266,
    width: 216.957,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_615",
    x1: 286.7,
    y1: 216.12,
    x2: 146.356,
    y2: 302.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_615",
    x1: 356.785,
    y1: 228.165,
    x2: 240.602,
    y2: 262.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_615",
    x1: 256.144,
    y1: 255.352,
    x2: 114.178,
    y2: 348.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_615",
    x1: 207.313,
    y1: 309.713,
    x2: 91.1172,
    y2: 344.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_615",
    x1: 362.661,
    y1: 309.439,
    x2: 220.53,
    y2: 403.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_106_615",
    x1: 325.138,
    y1: 347.528,
    x2: 184.755,
    y2: 434.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0489D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC2CE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "matrix(-1 0 0 1 362 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDng);
export default __webpack_public_path__ + "static/media/dng.fdc89637b79fce2e5ede053bab844be3.svg";
export { ForwardRef as ReactComponent };